import { render, staticRenderFns } from "./ProjectsExpensesInput.vue?vue&type=template&id=5732ac3e"
import script from "./ProjectsExpensesInput.vue?vue&type=script&lang=js"
export * from "./ProjectsExpensesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports